const styles = (theme) => ({
  listItem: {
    padding: '10px 20px 10px 15px',
    cursor: 'pointer',

    [theme.breakpoints.up('md')]: {
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.08)',
      },
    },
  },
  faqIcon: {
    maxWidth: 22,
    maxHeight: 22,
    width: '100%',
    height: '100%',
  },
});

export default styles;
